import { z } from 'zod';

const selectedId = z
  .string()
  .min(1)
  .nullish()
  .transform((value) => value ?? null);
export const cosmeticSchema = z.object({
  id: z.string().min(1),
  key: z.string(),
  kind: z.enum(['avatar', 'frame']),
  name: z.string(),
  imageUrl: z.string(),
  available: z.boolean(),
  owned: z.boolean(),
  selected: z.boolean(),
  unlockType: z.enum(['default', 'free', 'campaign', 'purchase']),
  unlockRef: z.string().optional().default(''),
  priceCoins: z.number().int().nonnegative(),
});
export const cosmeticSelectionSchema = z.object({
  selectedAvatarId: selectedId,
  selectedAvatarUrl: z.string().nullish(),
  selectedFrameId: selectedId,
  selectedFrameUrl: z.string().nullish(),
});
export const cosmeticsCatalogSchema = z.object({
  items: z.array(cosmeticSchema),
  selectedAvatarId: selectedId,
  selectedFrameId: selectedId,
});
